import { render } from "./LiveExam.vue?vue&type=template&id=7a3a8372&scoped=true"
import script from "./LiveExam.vue?vue&type=script&lang=js"
export * from "./LiveExam.vue?vue&type=script&lang=js"

import "./LiveExam.vue?vue&type=style&index=0&id=7a3a8372&scoped=true&lang=css"

import exportComponent from "/var/www/html/bcsprostuti-web-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a3a8372"]])

export default __exports__